export default __webpack_public_path__ + "img/bd91558c041b05c633ce4550412fd46a.png";